import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AddModeratorOutlined, ContactMailOutlined } from '@mui/icons-material';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { Checkbox, Tooltip, Typography, Stack } from '@mui/material';
import { ColorsV2 } from 'app/constants/color';
import { Buttons } from 'app/constants/sizing';

const AddToTOSButton = ({
  questionId,
  tosBatch,
  addQuestion,
  removeQuestion,
  resetCheckbox,
  answer,
}) => {
  const [checked, setChecked] = useState(false);
  const [recipients, setRecipients] = useState([]);

  const handleChange = event => {
    setChecked(event.target.checked);
    event.target.checked ? addQuestion(questionId) : removeQuestion(questionId);
  };

  useEffect(() => {
    setChecked(false);
  }, [resetCheckbox]);

  useEffect(() => {
    tosBatch.map(question => {
      if (question === questionId) {
        setChecked(true);
      }
    });
  }, [questionId, resetCheckbox]);

  useEffect(() => {
    if (answer) {
      setRecipients(answer.tosRecipients?.map(rec => rec.email));
    }
  }, [answer]);

  const { t } = useTranslation('translation', { keyPrefix: 'gap_analysis' });

  return (
    <Stack direction='row' alignItems='center'>
      <Tooltip
        title={
          <Typography variant='caption'>
            {checked ? t('tos_remove_tooltip') : t('tos_add_tooltip')}
          </Typography>
        }
      >
        <Checkbox
          icon={<AddModeratorOutlined />}
          checkedIcon={<VerifiedUserIcon />}
          checked={checked}
          onChange={handleChange}
          style={{ justifySelf: 'right' }}
          sx={{
            ...Buttons.baseStyle.iconButton,
            '&.Mui-checked': {
              color: ColorsV2.white,
            },
          }}
        ></Checkbox>
      </Tooltip>
      {recipients !== undefined ? (
        <Tooltip
          title={
            <Stack direction='column'>
              <Typography variant='caption'>{t('tos_previously_assigned')}:</Typography>
              {recipients.map((email) => (
                <Typography variant='caption' key={email}>
                  {email}
                </Typography>
              ))}
            </Stack>
          }
        >
          <Checkbox
            icon={<ContactMailOutlined />}
            checkedIcon={<ContactMailOutlined />}
            style={{ justifySelf: 'right' }}
            disableRipple
            sx={{
              color: ColorsV2.textInfo,
              '&.Mui-checked': {
                color: ColorsV2.textInfo,
              },
              '&.Mui-clicked': {
                color: ColorsV2.textInfo,
                bgcolor: ColorsV2.primary,
              },
              '&:hover': {
                color: ColorsV2.textInfo,
                bgcolor: ColorsV2.primary,
              },
            }}
          ></Checkbox>
        </Tooltip>
      ) : (
        <></>
      )}
    </Stack>
  );
};

export default AddToTOSButton;
